import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tasks-list" }
const _hoisted_2 = {
  key: 0,
  class: "title title--h2"
}
const _hoisted_3 = {
  key: 1,
  class: "title title--h2"
}
const _hoisted_4 = {
  key: 2,
  class: "title title--h2"
}
const _hoisted_5 = { class: "tasks-list__list" }

import TasksListTask from '@/components/TasksListTask.vue';
import LoadingIndicator from '@/components/UI/LoadingIndicator.vue';

import { Task } from '@/types/task';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

export default /*#__PURE__*/_defineComponent({
  __name: 'TasksList',
  props: {
    tasks: {},
    isLoading: { type: Boolean },
    isError: { type: Boolean },
    completed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { useActions } = createNamespacedHelpers('taskModule');



const { deleteTask, completeTask } = useActions(['deleteTask', 'completeTask']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.completed)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Текущие задачи "))
      : (_openBlock(), _createElementBlock("h2", _hoisted_3, " Завершенные задачи ")),
    (props.tasks.length === 0 && props.isLoading === false)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_4, " Создайте задачу или измените условия фильтрации "))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_5, [
      _createVNode(_TransitionGroup, { name: "task-list" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tasks, (task) => {
            return (_openBlock(), _createBlock(TasksListTask, {
              key: task.id,
              task: task,
              completed: props.completed,
              "is-error": props.isError,
              onDeleteTask: _unref(deleteTask),
              onCompleteTask: _unref(completeTask)
            }, null, 8, ["task", "completed", "is-error", "onDeleteTask", "onCompleteTask"]))
          }), 128)),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})